<template>
  <div class="text-center mb-5 text-muted">
    <router-link to="/" class="d-block auth-logo">
      <img
          src="@/assets/images/logo-dark.png"
          alt=""
          height="38"
          class="auth-logo-dark mx-auto"
      />
      <img
          src="@/assets/images/logo-light.png"
          alt=""
          height="38"
          class="auth-logo-light mx-auto"
      />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "LogoHeader"
}
</script>

<style scoped>

</style>